import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Homepage from "./pages/Homepage";
import AboutUs from "./pages/AboutUs";
import Laban from "./pages/Laban";
import Vinzz from "./pages/Vinzz";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import Pricing from "./pages/Pricing";
import Success from "./pages/Success";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/gone-dark" element={<AboutUs />} />
        <Route path="/laban" element={<Laban />} />
        <Route path="/team" element={<Team />} />
        <Route path="/vinzz" element={<Vinzz />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/success" element={<Success />} />
      </Routes>
    </>
  );
}

export default App;
